import { useState, useEffect } from "react";
import { getEstablishedContacts, getConfig, getContacts } from "./Api";
export const useEstablishedContacts = () => {
	const [contacts, setContacts] = useState([]);
	const updateContacts = async () => {
		const data = await getEstablishedContacts();
		setContacts(data);
	};
	useEffect(() => {
		updateContacts();
	}, []);
	return [contacts, updateContacts];
};

export const usePrsInfo = () => {
	const [prsInfo, setPrsInfo] = useState({});
	const updateInfo = async () => {
		const data = await getConfig();
		setPrsInfo(data);
	};
	useEffect(() => {
		updateInfo();
	}, []);
	return prsInfo;
};

export const useContacts = () => {
	const [contacts, setContacts] = useState([]);
	useEffect(() => {
		const updateContacts = async () => {
			const data = await getContacts();
			setContacts(data);
		};
		updateContacts();
	}, []);
	return contacts;
};
